<div class="multi-data-container" vdmsHqUiDialogPageHost [sharedE2eId]="'suppliers-wrapper'">
  <vdms-hq-ui-data-presentation-header
    [title]="'pages.home.menu.suppliers'"
    (action)="handleAction($event)"
    [actions]="headerActions$ | async"
  />
  @if (viewConfiguration$ | async; as config) {
    <vdms-hq-ui-multiple-data-presentation
      [tableId]="'suppliers-table'"
      [dataSource]="suppliersDataSource"
      [configuration]="config"
      (action)="handleAction($event)"
    >
      <vdms-hq-dynamic-form-group-renderer filters [form]="filters" [fieldsConfig]="filtersConfig" [fullWidth]="true" />
    </vdms-hq-ui-multiple-data-presentation>
  }
</div>
